/**
 * App Action 命名空间
 */
export const appActionNamespace = 'fanfanlo/javajs/v1/project/components/actions/app/'
